import { render, staticRenderFns } from "./Modgroup.vue?vue&type=template&id=5f841c50"
import script from "./Modgroup.vue?vue&type=script&lang=ts"
export * from "./Modgroup.vue?vue&type=script&lang=ts"
import style0 from "./Modgroup.vue?vue&type=style&index=0&id=5f841c50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports